import { render, staticRenderFns } from "./TrainingPlan.vue?vue&type=template&id=66e58ac6&scoped=true&"
import script from "./TrainingPlan.vue?vue&type=script&lang=js&"
export * from "./TrainingPlan.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlan.vue?vue&type=style&index=0&id=66e58ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e58ac6",
  null
  
)

export default component.exports